import { render, staticRenderFns } from "./FormSectionCard.vue?vue&type=template&id=caa0db6c"
import script from "./FormSectionCard.vue?vue&type=script&lang=js"
export * from "./FormSectionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports